import React from "react";

const DropDownItem = ({ handleListClick, id, disabled, index, title }) => {
  const handleItemClick = () => {
    handleListClick(title, id, index);

  };
  return (
    <li
      id={`item-${id}`}
      className={`${disabled ? "prevent not-checked" : ""}`}
      onClick={handleItemClick}
    >
      {title == "Offline"?
       <div style={{color:'red'}}>Offline</div>
       :
       <div>{title}</div>
       }     
    </li>
  );
};

export default DropDownItem;
